import { Base } from '@studiometa/js-toolkit';
// import MapPanel from './MapPanel.js';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @extends {Base<ComponentProps>}
 */
export default class Map extends Base {
  isVisible = false;

  currenItem = null;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Map',
    refs: ['container', 'panel', 'json', 'items[]'],
    options: {
      noPanel: {
        type: Boolean,
        default: true,
      },
      lat: {
        type: Number,
        default: 46.630765,
      },
      lng: {
        type: Number,
        default: 1.850898,
      },
    },
  };

  /**
   *
   */
  mounted() {
    if (this.$refs.json) {
      this.data = JSON.parse(this.$refs.json.innerHTML);
    }

    mapboxgl.accessToken =
      'pk.eyJ1IjoiZ3VpbG0iLCJhIjoiY20zemtpOWM3MGlreTJqczVmaWczOGZmZyJ9.g7cBC5Qhr3bg1jlihK8tWA';
    this.map = new mapboxgl.Map({
      container: this.$refs.container,
      center: [7.2586207, 48.767098],
      style: 'mapbox://styles/mapbox/outdoors-v12',
      zoom: 7,
      cooperativeGestures: true,
    });

    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
    });

    this.map.addControl(nav, 'top-right');

    this.setMarkers();
  }

  /**
   *
   */
  setMarkers() {
    this.data.forEach((element) => {
      if (element.lat !== 0) {
        this.createMarker(element);
      }
    });
  }

  /**
   * Over on item
   * @param {*} event
   */
  onItemsMouseover(event) {
    if (this.currentMarker) {
      this.currentMarker.classList.remove('marker--current');
    }

    if (this.currentItem) {
      this.currentItem.classList.remove('bg-black/10');
    }

    this.currentItem = event.currentTarget;
    const { item } = this.currentItem.dataset;
    this.currentMarker = document.querySelector(`[data-slug="${item}"]`);

    this.setActive();
  }

  /**
   * Active items
   */
  setActive() {
    this.currentItem.classList.add('bg-black/10');
    if (this.currentMarker) {
      this.currentMarker.classList.add('marker--current');
    }
  }

  /**
   * Create marker on map
   * @param  {object} element element
   * @returns {void}
   */
  createMarker(element) {
    const el = document.createElement('div');
    el.className = 'marker';
    el.style.width = `30px`;
    el.style.height = `38px`;
    el.dataset.slug = element.slug;
    el.style.backgroundSize = '100%';

    const marker = new mapboxgl.Marker({
      element: el,
      anchor: 'bottom',
    })
      .setLngLat([element.coord.lng, element.coord.lat])
      .addTo(this.map);

    el.addEventListener('mouseover', () => {
      if (this.currentItem) {
        this.currentItem.classList.remove('bg-black/10');
      }

      if (this.currentMarker) {
        this.currentMarker.classList.remove('marker--current');
      }

      this.currentMarker = marker._element;
      const { slug } = this.currentMarker.dataset;
      this.currentItem = document.querySelector(`[data-item="${slug}"]`);
      this.setActive();
    });
  }
}
